import React from 'react';
import { DocumentLabel, ProjectDocument, useProjectDocumentsService } from 'nekst-api';
import {
  AfterSubmitFunc,
  Dropdown,
  FormTemplate,
  SimpleBlock,
  Text,
  useFormContext, useListContext,
  useShowContextRequired
} from 'ui-builder';
import { usePopupFormManager } from 'features/nekst-widgets';

type AssignLabelFormData = {
  labelId: number,
  _fileName: string,
}

function FileName() {
  const formContext = useFormContext<AssignLabelFormData>();

  return (
    <SimpleBlock>
      <Text bold>Document:</Text>
      <Text>
        {' '}
        {formContext.data?._fileName}
      </Text>
    </SimpleBlock>
  );
}

export function AssignLabelForm(
  props: {
    document: ProjectDocument,
    availableLabels: DocumentLabel[],
    afterSubmitFunc?: AfterSubmitFunc,
  },
) {
  const projectDocumentsService = useProjectDocumentsService();
  return (
    <FormTemplate<AssignLabelFormData>
      submitFormFunc={async (data) => {
        await projectDocumentsService.assignLabelToDocument(props.document.id, data.labelId);
        return data;
      }}
      afterSubmitFunc={props.afterSubmitFunc}
      title="Add Label"
      initialData={{
        _fileName: props.document._file!.name,
      } as AssignLabelFormData}
    >
      <Dropdown
        label="Label"
        options={props.availableLabels.map((item) => ({
          label: item.name,
          value: item.id,
        }))}
        source="labelId"
      />
      <FileName />
    </FormTemplate>
  );
}

export function useAssignLabelFormHelper() {
  const listContext = useListContext<ProjectDocument>();

  const hasUnassignedLabels = () => {
    return listContext.data!.filter((item) => !item._file && item._label).length > 0;
  };

  const showContext = useShowContextRequired<ProjectDocument>();

  const currentItem = showContext.data;

  const popupFormManager = usePopupFormManager();

  const openForm = () => {
    const labels = listContext
      .data!
      .filter((item) => !item._file && item._label)
      .map((item) => item._label!);

    const document = showContext.data!;

    popupFormManager.openForm(<AssignLabelForm document={document} availableLabels={labels} />);
  }

  return {
    isVisible: () => hasUnassignedLabels() && !currentItem._label,
    openForm,
  };
}
